import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React from 'react';
import { BsFillCircleFill, BsFillSquareFill } from 'react-icons/bs';
import { changeObjKey } from './DataCustomizer';



const PriceVsNAVChart = ({ chartData = [] }) => {
    // portfolioType 1 = curated , 2 = custom, 0 = for individual funds
    const [noChart, setnoChart] = React.useState(false);
    const fundColors = ['#4284f3', '#fabc05', '#24c1e0', '#fa7b16', '#b74447', '#333', 'purple', 'violet', 'red', 'darkgreen']
    try {
        var conf = {
            chart: {
                backgroundColor: "transparent"
            },
            title: {
                text: ''
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                visible: false,
                tickAmount: 5,
                gridLineDashStyle: 'longdash',
                title: {
                    text: ''
                },
                gridLineColor: 'var(--border)',
                labels: {
                    format: '₹{value}'
                },
            },
            xAxis: [{
                type: 'datetime',
                dateTimeLabelFormats: {
                    millisecond: '%H:%M:%S.%L',
                    second: '%H:%M:%S',
                    minute: '%H:%M',
                    hour: '%H:%M',
                    day: '%eth %b',
                    week: '%eth %b',
                    month: '%b \'%y',
                    year: '%Y'
                },
                lineColor: "var(--divider)",
                tickColor: "var(--divider)",
            }
            ],
            legend: {
                enabled: false
            },
            plotOptions: {
                areaspline: {
                    threshold: null
                },
                series: {
                    label: {
                        connectorAllowed: false
                    },
                    marker: {
                        enabled: false
                    }
                }
            },
            tooltip: {
                shared: true,
                valueDecimals: 0,
                valuePrefix: '₹',
            },
            credits: {
                enabled: false
            },
            boost: {
                useGPUTranslations: true,
            },
            series: [
                {
                    name: "NAV", turboThreshold: 9e9,
                    color: fundColors[0],
                    type: "areaspline",
                    fillColor: {
                        linearGradient: {
                            x1: 0,
                            x2: 0,
                            y1: 0,
                            y2: 1
                        },
                        stops: [
                            [0, fundColors[0] + "77"],
                            [0.7, fundColors[0] + "11"]
                        ]
                    },
                    data: changeObjKey(chartData, ["NAV", "Date"], ["y", "x"], "mfetfChart", 1)
                }, {
                    name: "Price", turboThreshold: 9e9,
                    color: fundColors[1],
                    type: "areaspline",
                    fillColor: {
                        linearGradient: {
                            x1: 0,
                            x2: 0,
                            y1: 0,
                            y2: 1
                        },
                        stops: [
                            [0, fundColors[1] + "77"],
                            [0.7, fundColors[1] + "11"]
                        ]
                    },
                    data: changeObjKey(chartData, ["price", "Date"], ["y", "x"], "mfetfChart", 1)
                }
            ].reverse(),
            scrollbar: {
                enabled: false
            },
            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 400
                    },
                }]
            },

        };
    } catch (error) {
        console.log("SDF", error)
        setnoChart(true)
    }


    const options = {
        global: {
            useUTC: true
        },
        lang: {
            decimalPoint: '.',
            thousandsSep: ','
        }
    };


    const ContentBeforeChart = () => {
        try {
            return <div style={{ gap: '1rem', flexWrap: 'wrap', alignItems: "center" }}>
                <span style={{ flex: 1, display: "flex", flexDirection: "row", marginBottom: "1rem" }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: "2rem" }}>
                        <span>
                            <span className='textXS w-700' style={{ color: 'var(--black)', display: "flex", alignItems: "center", gap: "0.5rem" }}>
                                <BsFillSquareFill color={fundColors[1]} size={"0.5rem"} />Last closing Price
                            </span>
                        </span>
                        <span>
                            <span className='textXS w-700' style={{ color: 'var(--black)', display: "flex", alignItems: "center", gap: "0.5rem" }}>
                                <BsFillSquareFill color={fundColors[0]} size={"0.5rem"} /> Last closing NAV
                            </span>
                        </span>
                    </div>
                </span>
            </div>
        } catch (error) {
            console.log(error)
            return <></>
        }
    };



    try {
        return (
            noChart ? <div className='textXS' style={{ margin: "4rem", textAlign: "center" }}>
                No chart data available!
            </div>
                : <span style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', }}>
                    <ContentBeforeChart />
                    <HighchartsReact containerProps={{ style: { height: "20.8rem" } }} highcharts={Highcharts} options={conf} />
                    {/* <ContentAfterChart /> */}
                </span>
        );
    } catch (error) {
        console.log(error)
        return <div className='textSM' style={{ margin: "4%", textAlign: "center" }}>
            No chart data available!
        </div>
    }
};
export default PriceVsNAVChart;